export const tr = {
    'product-description-cannot-be-more-than-max': {
        one: 'Ürün açıklaması en fazla {maxLength} karakter olabilir',
        some: 'Ürün açıklaması en fazla {maxLength} karakter olabilir',
        many: 'Ürün açıklaması en fazla {maxLength} karakter olabilir',
        none: 'Ürün açıklaması en fazla {maxLength} karakter olabilir'
    },
    'product-name-cannot-be-more-than-max': {
        one: 'Ürün adı en fazla {maxLength} karakter olabilir',
        some: 'Ürün adı en fazla {maxLength} karakter olabilir',
        many: 'Ürün adı en fazla {maxLength} karakter olabilir',
        none: 'Ürün adı en fazla {maxLength} karakter olabilir'
    },
    'product-with-this-name-already-exists': 'Bu isimde bir ürün zaten var',
    'unknown-error-text': 'Ürün güncellenemedi'
};
